import {hoistCmp, uses} from '@xh/hoist/core';
import {RzxAppModel} from '../../RzxAppModel';
import {appBar} from '@xh/hoist/desktop/cmp/appbar';
import {tabSwitcher} from '@xh/hoist/desktop/cmp/tab';
import {welcomeMsg} from '../welcomeMsg/WelcomeMsg';
import {wsIndicator} from '../wsIndicator/WsIndicator';
import {img} from '@xh/hoist/cmp/layout';
import {aiChatButton} from '../aiChat/AiChatPanel';

export const appNavBar = hoistCmp.factory({
    model: uses(RzxAppModel),
    render() {
        return appBar({
            testId: 'app-nav-bar',
            title: 'RZX',
            icon: img({src: '/public/favicon-512.png', height: 24, style: {marginTop: 5}}),
            leftItems: [tabSwitcher({enableOverflow: true, testId: 'app-tab-switcher'})],
            rightItems: [aiChatButton(), wsIndicator()],
            hideWhatsNewButton: false,
            hideRefreshButton: true,
            appMenuButtonProps: {
                hideLogoutItem: false,
                extraItems: [welcomeMsg()]
            }
        });
    }
});
